(function ($) {
  Drupal.behaviors.aerinFragranceFinderResultFormatterV1 = {
    attach: function (context) {
      const $resultTout = $('.js-aerin-fragrance-finder-result-formatter__tout', context);

      if (window.self !== window.top) {
        $resultTout.addClass('iframed');
      }
    }
  };
})(jQuery);
